import React from 'react';
import { useDispatch } from 'react-redux';
import { RootState } from '../../redux/rootReducer';
import { loginUser } from '../../redux/slices/authSlice';
import Card from 'react-bootstrap/Card';
import Button from '../atoms/Button';
import { Container } from 'react-bootstrap';
import { ThunkDispatch, Action } from "@reduxjs/toolkit";
import { Link } from 'react-router-dom';


const LoginPage: React.FC = () => {
    const dispatch = useDispatch<ThunkDispatch<RootState, void, Action>>();
  return (
    <Container>
      <br />
      <Card style={{ width: '18rem', margin: '0 auto' }}>
        <Card.Body>
          <Card.Title>Login</Card.Title>
            <Button className="btn btn-primary w-100" onClick={() => dispatch(loginUser())} >Log In</Button>
            <div className="mt-3 text-center">
              <Link to="/password-reset">Forgot Password?</Link>
            </div>
        </Card.Body>
      </Card></Container>
  );
};

export default LoginPage;
